import { configureStore } from "@reduxjs/toolkit";

import loaneeDetailsReducer from "../features/loaneeDetails/LoaneeDetails";

export const store = configureStore({
  reducer: {
    loaneeDetails: loaneeDetailsReducer,
  },
});
